<template lang="pug">
    .quote(:class='color' ref='animation')
        .quote__content(v-html='text' ref='text')
        .quote__decor(ref='decor')
            svg(width='100%' viewBox='0 0 110 8' preserveAspectRatio='xMaxYMid slice')
                //- path(d='M2 2H98' stroke-width='3' stroke-linecap='round' stroke-linejoin='round' stroke-dasharray='1 10')
                g.circle
                    circle(cx='4' cy='4' r='2')
                g.circle
                    circle(cx='17' cy='4' r='2')
                g.circle
                    circle(cx='30' cy='4' r='2')
                g.circle
                    circle(cx='43' cy='4' r='2')
                g.circle
                    circle(cx='56' cy='4' r='2')
                g.circle
                    circle(cx='69' cy='4' r='2')
                g.circle
                    circle(cx='82' cy='4' r='2')
                g.circle
                    circle(cx='95' cy='4' r='2')
                g.circle
                    circle(cx='108' cy='4' r='2')
</template>

<script>
import {mixinAnimation} from '../mixins/mixinAnimation';
import {gsap} from 'gsap';

export default {
    data() {
        return {
            timeline: null,
            instance: null,
            isInited: false
        };
    },
    props: {
        text: String,
        isActive: Boolean,
        color: String,
        side: String
    },
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll('top-bottom', 'top-middle');
        },
        createTimeline() {
            let circles = this.$refs.decor.querySelectorAll('.circle');
            this.timeline = gsap.timeline();
            let positionX = this.side === 'left' ? 50 : -50,
                from = this.side === 'left' ? 'start' : 'end',
                x = this.side === 'left' ? 10 : -10;
            this.timeline
                .fromTo(circles, {opacity: 0, x}, {duration: 0.3, opacity: 1, x: 0, stagger: {each: 0.1, from}, ease: 'none'}, 0)
                .fromTo(this.$refs.text, {opacity: 0, x: positionX}, {duration: 0.4, opacity: 1, x: 0, ease: 'none'}, 0.4);
            //.fromTo(this.$refs.animation, {x: positionX}, {duration: 1, x: 0, ease: 'none'})
        }
    }
};
</script>
<style lang="scss">
.black {
    .quote {
        color: var(--theme);
        &__decor {
            path {
                stroke: var(--theme);
            }
            circle {
                fill: var(--theme);
            }
        }
    }
}
.quote {
    color: var(--color-black);
    &__content {
        font-family: var(--font-accent);
        font-weight: 800;
        font-size: 25px;
        line-height: 1.2;
        color: currentColor;
        position: relative;
        padding-top: 1em;
        transform: translate(calc(30% - var(--translateQ) * 30%));
        @media screen and (--viewport-laptop) {
            font-size: 20px;
        }

        @media screen and (--viewport-tablet) {
            font-size: 15px;
        }
    }

    &__decor {
        position: absolute;
        top: 0;
        left: 0;
        height: 5px;
        width: 33%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        @media (--viewport-tablet) {
            width: var(--grid-column-mobile);
            margin-right: var(--grid-column-mobile);
        }
        // path {
        //     stroke: var(--color-black);
        // }
        circle {
            fill: var(--color-black);
        }
    }

    @media (--viewport-tablet) {
        display: none;
    }
}
@keyframes fading {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(0);
    }
    100% {
        transform: scale(1);
    }
}
</style>
